import React from 'react';
import PropTypes from 'prop-types';
import CustomReactMarkdown from '../MarkdownRenderers/CustomReactMarkdown';
import IconCheckmark from '../../icons/icon-checkmark-circle.svg';
import IconLeaf from '../../icons/icon-leaf.svg';
import IconGift from '../../icons/icon-gift.svg';
import IconInstall from '../../icons/icon-install.svg';
import IconCart from '../../icons/icon-cart.svg';
import WrenchScrewdriver from '../../icons/round-wrench-screwdriver.svg';
import { styler } from '../../helpers/classNameHelper';
import Link from '../Link/Link';
import OpenLinkIcon from '../../icons/open-link-icon.svg';

const iconMap = {
  checkmark: IconCheckmark,
  leaf: IconLeaf,
  gift: IconGift,
  install: IconInstall,
  screwdriver: WrenchScrewdriver,
  cart: IconCart
};

const OfferCard = ({
  buttonText,
  buttonUrl,
  description,
  disclaimer,
  icon,
  name,
  styleFlag,
  isSetupGuide,
  title,
  track,
}) => {
  const Icon = icon && iconMap[icon];

  const handleEvent = (event) => {
    if (!track) {
      return;
    }

    event.preventDefault();
    track(() => {
      window.open(buttonUrl);
    });
  };

  const style = styler(styleFlag);

  const descriptionString = description instanceof Array ? description.join('\n\n') : description;

  // Pass an empty string if track is present because track will handle the buttonUrl
  const href = track ? '' : buttonUrl;

  return (
    <div className={style('offer-card')}>
      {Icon && <Icon className={style('offer-card__icon')} />}
      <div className={style('offer-card__headline')}>{name}</div>
      <h3 className={style('offer-card__title')}>{title}</h3>
      <CustomReactMarkdown className={style('offer-card__body')} source={descriptionString} />
      {buttonUrl && buttonText && (
        <Link
          action={handleEvent}
          href={href}
          className="offer-card__cta"
        >
          {buttonText}
        </Link>
      )}
      {disclaimer && (
        isSetupGuide
        ? <div className={style('offer-card__disclaimer')}>
            <CustomReactMarkdown source={disclaimer.prefix} />
            <Link href={disclaimer.url} className={style('offer-card__disclaimer_link')} external={true}>
              {disclaimer.linkText}
              <OpenLinkIcon className="offer-card__open-link-icon" /></Link>
            <CustomReactMarkdown source={disclaimer.suffix} />
          </div>
        : <CustomReactMarkdown className={style('offer-card__disclaimer')} source={disclaimer} />)}
    </div>
  );
};

OfferCard.propTypes = {
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  description: PropTypes.string.isRequired,
  disclaimer: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string,
  styleFlag: PropTypes.string,
  isSetupGuide: PropTypes.bool,
  title: PropTypes.string.isRequired,
  track: PropTypes.func,
};

OfferCard.defaultProps = {
  buttonText: null,
  buttonUrl: null,
  disclaimer: null,
  icon: null,
  name: null,
  styleFlag: null,
  isSetupGuide: false,
  track: null,
};

export default OfferCard;
